module.exports = __webpack_public_path__ + "static/media/ic_social_facebook.9a8ec1aa.svg";